export function formatCampaignType(rawType?: string | null): string {
  if (!rawType) return "Кампания Директа";
  switch (rawType.toUpperCase()) {
    case "TEXT_CAMPAIGN":
      return "Текстово-графическая";
    case "UNIFIED_CAMPAIGN":
      return "Единая перфоманс-кампания (ЕПК)";
    case "SMART_CAMPAIGN":
      return "Смарт-баннеры";
    case "DYNAMIC_TEXT_CAMPAIGN":
      return "Динамические объявления";
    case "CPM_BANNER_CAMPAIGN":
      return "Медийная кампания";
    case "MOBILE_APP_CAMPAIGN":
      return "Реклама приложений";
    default:
      return rawType;
  }
}

export function formatPlacementTypes(
  placements?: string[] | null,
  fallback?: string
): string {
  if (!placements || placements.length === 0) {
    return fallback || "Поиск и РСЯ";
  }
  const hasSearch = placements.some((p) => p.toUpperCase().includes("SEARCH"));
  const hasNetwork = placements.some((p) => p.toUpperCase().includes("NETWORK"));

  if (hasSearch && hasNetwork) {
    return "Поиск и РСЯ";
  }
  if (hasSearch) {
    return "Поиск Яндекса";
  }
  if (hasNetwork) {
    return "Рекламная сеть (РСЯ)";
  }
  return placements.join(", ");
}
